<div class="container-fluid" style="padding: 0">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="search" nzTheme="outline"></i> Search
  </div>
  <form
    nz-form
    [formGroup]="searchForm"
    class="ant-advanced-search-form"
    (ngSubmit)="submitSearchForm()"
    style="
      padding: 24px;
      background: #fbfbfb;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
    "
  >
    <div class="row">
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>STP Name</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                formControlName="stpName"
                nzShowSearch
                nzServerSearch
                nzAllowClear
                nzPlaceHolder="Search STP name"
                [nzLoading]="isStpLoading"
                (nzOnSearch)="onStpSearch($event)"
              >
                <nz-option
                  *ngFor="let stp of stpOptions"
                  [nzLabel]="stp.stpName"
                  [nzValue]="stp.stpName"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Application Status</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                formControlName="applicationStatus"
                nzAllowClear
                nzPlaceHolder="Application Status"
              >
                <nz-option
                  *ngFor="let status of applicationStatuses"
                  [nzLabel]="status"
                  [nzValue]="status"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Date Range (Action Time)</nz-form-label>
          <nz-form-item>
            <nz-range-picker
              formControlName="dateRange"
              (ngModelChange)="onDateRangeChange()"
              nzFormat="yyyy-MM-dd"
              nzPlaceHolder="Select date range"
              style="width: 100%"
            ></nz-range-picker>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Table Name</nz-form-label>
          <nz-form-item>
            <nz-form-control nzErrorTip="Please insert valid table name">
              <input
                nz-input
                placeholder="Table Name"
                formControlName="tableName"
                [nzAutocomplete]="tableNameAuto"
              />
              <nz-autocomplete #tableNameAuto>
                <nz-auto-option
                  *ngFor="let option of tableNameOptions"
                  [nzValue]="option.value"
                  [nzLabel]="option.label"
                >
                  {{ option.label }}
                  <span class="text-muted">({{ option.value }})</span>
                </nz-auto-option>
              </nz-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Description</nz-form-label>
          <nz-form-item>
            <nz-form-control nzErrorTip="Please insert valid description">
              <input
                nz-input
                placeholder="Description"
                formControlName="description"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>User Name</nz-form-label>
          <nz-form-item>
            <nz-form-control nzErrorTip="Please insert valid user name">
              <input
                nz-input
                placeholder="User Name"
                formControlName="userName"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Action By (User Type)</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                formControlName="actorType"
                nzAllowClear
                nzPlaceHolder="User Type"
              >
                <nz-option
                  *ngFor="let type of actorTypes"
                  [nzLabel]="type"
                  [nzValue]="type"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Action Type</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                formControlName="actionType"
                nzPlaceHolder="Action Type"
              >
                <nz-option
                  *ngFor="let data of actionTypes"
                  [nzValue]="data?.id"
                  [nzLabel]="data.name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>

    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area text-right">
        <button
          class="ml-2 col-md-2 col-sm-12 mt-2"
          nz-button
          [nzType]="'primary'"
        >
          Search
        </button>
        <button
          class="btn-success ml-2 col-md-2 col-sm-12 mt-2"
          nz-button
          (click)="onRefresh()"
        >
          Refresh Data
        </button>
        <!-- <button
          type="button"
          class="btn-info ml-2 col-md-2 col-sm-12 mt-2"
          (click)="onDownloadReport()"
          nz-button
        >
          Download Report
        </button> -->
      </div>
    </div>
  </form>

  <div class="ng-Header col-xs-12 mt-4">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> STP Activity
    Log
  </div>
  <div nz-col [nzSpan]="24">
    <nz-table
      #basicCrTable
      [nzData]="activityLogList"
      nzTableLayout="fixed"
      nzShowSizeChanger
      nzBordered
      nzSize="middle"
      nzAlign="middle"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [(nzPageSize)]="size"
      [nzShowTotal]="totalRowRangeTemplate"
      [(nzPageIndex)]="page"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzPaginationPosition]="'both'"
      [nzScroll]="{ x: '1600px' }"
    >
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr>
          <th style="width: 50px; text-align: center" rowspan="1">SI.</th>
          <th style="text-align: center" rowspan="1">STP Name</th>
          <th style="width: 190px; text-align: center" rowspan="1">
            Application Status
          </th>
          <th
            style="text-align: center"
            rowspan="1"
            nzColumnKey="table_name"
            [nzSortFn]="true"
          >
            Table Name
          </th>
          <th
            style="text-align: center"
            rowspan="1"
            nzColumnKey="description"
            [nzSortFn]="true"
          >
            Description
          </th>
          <th
            style="width: 110px; text-align: center"
            rowspan="1"
            nzColumnKey="action_type"
            [nzSortFn]="true"
          >
            Action Type
          </th>
          <th
            style="width: 170px; text-align: center"
            rowspan="1"
            nzColumnKey="action_time"
            [nzSortFn]="true"
            nzSortOrder="descend"
          >
            Action Time
          </th>
          <th
            style="width: 130px; text-align: center"
            rowspan="1"
            nzColumnKey="action_ip"
            [nzSortFn]="true"
          >
            Action IP
          </th>
          <th style="text-align: center" rowspan="1">IP Location</th>
          <th style="text-align: center" rowspan="1">Action By</th>
          <th style="width: 90px; text-align: center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicCrTable.data; let i = index">
          <td style="text-align: center">
            {{ (page - 1) * size + 1 + i }}
          </td>
          <td style="text-align: center; vertical-align: middle">
            <span
              *ngIf="data.stpName; else noValue"
              class="truncate-cell"
              nz-tooltip
              [nzTooltipTitle]="data.stpName"
            >
              {{ data.stpName }}
            </span>
          </td>
          <td style="text-align: center; vertical-align: middle">
            <ng-container *ngIf="data.applicationStatus; else noValue">
              <nz-tag [nzColor]="applicationStatusColors[data.applicationStatus]">
                {{ data.applicationStatus }}
              </nz-tag>
              <button
                *ngIf="hasRejectionReason(data)"
                nz-button
                nzType="link"
                nzSize="small"
                class="reason-btn"
                (click)="openReason(data)"
              >
                Reason
              </button>
            </ng-container>
          </td>
          <td style="text-align: center; vertical-align: middle">
            {{ data.tableName }}
          </td>
          <td style="text-align: center; vertical-align: middle">
            {{ data.description }}
          </td>
          <td style="text-align: center; vertical-align: middle">
            <nz-tag [nzColor]="actionTypeColors[data.actionType]">
              {{ data.actionType }}
            </nz-tag>
          </td>
          <td style="text-align: center; vertical-align: middle">
            {{ data.actionTime | date : "dd-MM-yyyy hh:mm a" }}
          </td>
          <td style="text-align: center; vertical-align: middle">
            {{ data.actionIp || "—" }}
          </td>
          <td style="text-align: center; vertical-align: middle">
            <span
              *ngIf="data.actionLocation; else noValue"
              class="truncate-cell"
              nz-tooltip
              [nzTooltipTitle]="data.actionLocation"
            >
              {{ data.actionLocation }}
            </span>
          </td>
          <td style="text-align: center; vertical-align: middle">
            <div>{{ data.userEmail || "—" }}</div>
            <nz-tag
              *ngIf="data.actorType"
              [nzColor]="actorTypeColors[data.actorType]"
            >
              {{ data.actorType }}
            </nz-tag>
          </td>
          <td style="text-align: center; vertical-align: middle">
            <button nz-button nzType="link" (click)="openDetails(data)">
              <i nz-icon nzType="eye"></i> View
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>

<ng-template #noValue>—</ng-template>

<nz-modal
  [(nzVisible)]="isReasonVisible"
  nzTitle="Temporary Rejection Reason"
  [nzFooter]="reasonFooter"
  (nzOnCancel)="closeReason()"
>
  <ng-container *nzModalContent>
    <div style="white-space: pre-wrap; word-break: break-word">{{ reasonText }}</div>
  </ng-container>
  <ng-template #reasonFooter>
    <button nz-button nzType="primary" (click)="closeReason()">Close</button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isDetailVisible"
  nzTitle="Activity Log Details"
  [nzFooter]="null"
  nzWidth="90%"
  [nzBodyStyle]="{ 'max-height': '75vh', 'overflow-y': 'auto' }"
  (nzOnCancel)="closeDetails()"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="selectedLog as log">
      <nz-descriptions
        nzBordered
        nzSize="small"
        [nzColumn]="{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }"
      >
        <nz-descriptions-item nzTitle="STP Name" [nzSpan]="3">
          {{ log.stpName || "—" }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Application Status" [nzSpan]="3">
          <nz-tag
            *ngIf="log.applicationStatus; else noValue"
            [nzColor]="applicationStatusColors[log.applicationStatus]"
          >
            {{ log.applicationStatus }}
          </nz-tag>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Description" [nzSpan]="3">
          {{ log.description || "—" }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Table Name">
          {{ log.tableName || "—" }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Record ID">
          <ng-container *ngIf="log.recordId != null; else bulkRecord">
            {{ log.recordId }}
          </ng-container>
          <ng-template #bulkRecord>
            <span class="text-muted">— (bulk operation)</span>
          </ng-template>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Action Type">
          <nz-tag [nzColor]="actionTypeColors[log.actionType]">
            {{ log.actionType }}
          </nz-tag>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Action Time">
          {{ log.actionTime | date : "dd-MM-yyyy hh:mm a" }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Action By">
          {{ log.userEmail || "—" }}
          <nz-tag
            *ngIf="log.actorType"
            class="ml-2"
            [nzColor]="actorTypeColors[log.actorType]"
          >
            {{ log.actorType }}
          </nz-tag>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="IP">
          {{ log.actionIp || "—" }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="IP Location" [nzSpan]="3">
          {{ log.actionLocation || "—" }}
        </nz-descriptions-item>
        <!-- for Temporarily Rejected rows, remarks holds the rejection reason -->
        <nz-descriptions-item
          *ngIf="log.remarks"
          [nzTitle]="
            log.applicationStatus === temporarilyRejected
              ? 'Rejection Reason'
              : 'Remarks'
          "
          [nzSpan]="3"
        >
          <span style="white-space: pre-wrap">{{ log.remarks }}</span>
        </nz-descriptions-item>
      </nz-descriptions>

      <div class="data-heading">
        <ng-container [ngSwitch]="detailMode">
          <span *ngSwitchCase="'INSERT'">New Data</span>
          <span *ngSwitchCase="'DELETE'">Previous Data</span>
          <span *ngSwitchDefault>
            Data Comparison
            <span class="text-muted data-heading-hint">
              (changed fields: previous in red, new in green)
            </span>
          </span>
        </ng-container>
        <span *ngIf="isBulk" class="text-muted data-heading-hint">
          · {{ dataSections.length }} item(s)
        </span>
      </div>

      <nz-empty
        *ngIf="dataSections.length === 0"
        nzNotFoundContent="No data recorded"
      ></nz-empty>

      <!-- single record -->
      <ng-container *ngIf="!isBulk && dataSections.length">
        <ng-container
          *ngTemplateOutlet="sectionTpl; context: { $implicit: dataSections[0] }"
        ></ng-container>
      </ng-container>

      <!-- bulk operation: one collapsible panel per item -->
      <nz-collapse *ngIf="isBulk && dataSections.length">
        <nz-collapse-panel
          *ngFor="let section of dataSections; let first = first"
          [nzHeader]="panelHeader"
          [nzActive]="first && dataSections.length === 1"
        >
          <ng-template #panelHeader>
            {{ section.title }}
            <nz-tag
              *ngIf="detailMode === 'UPDATE' && section.changedCount"
              nzColor="gold"
              class="ml-2"
            >
              {{ section.changedCount }} changed
            </nz-tag>
          </ng-template>
          <ng-container
            *ngTemplateOutlet="sectionTpl; context: { $implicit: section }"
          ></ng-container>
        </nz-collapse-panel>
      </nz-collapse>
    </ng-container>
  </ng-container>
</nz-modal>

<ng-template #sectionTpl let-section>
  <div *ngIf="section.rawText != null">
    <div class="text-muted mb-1">
      Stored value is not valid JSON; showing it as-is.
    </div>
    <pre class="json-block">{{ section.rawText }}</pre>
  </div>

  <div
    *ngIf="section.rawText == null && section.rows.length === 0"
    class="p-3 text-center text-muted"
  >
    No data recorded
  </div>

  <table
    *ngIf="section.rows.length"
    class="table table-bordered w-100 log-data-table"
  >
    <thead>
      <tr>
        <th class="field-col">Field</th>
        <th *ngIf="detailMode !== 'INSERT'">Previous</th>
        <th *ngIf="detailMode !== 'DELETE'">New</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of section.rows" [class.changed-row]="row.changed">
        <td
          class="field-col"
          [ngStyle]="row.changed ? changeStyles.field : null"
        >
          {{ row.label }}
        </td>
        <td
          *ngIf="detailMode !== 'INSERT'"
          class="previous-cell"
          [ngStyle]="row.changed ? changeStyles.previousCell : null"
        >
          <ng-container
            *ngTemplateOutlet="
              valueTpl;
              context: { $implicit: row.previous, markClass: 'diff-removed' }
            "
          ></ng-container>
        </td>
        <td
          *ngIf="detailMode !== 'DELETE'"
          class="new-cell"
          [ngStyle]="row.changed ? changeStyles.newCell : null"
        >
          <ng-container
            *ngTemplateOutlet="
              valueTpl;
              context: { $implicit: row.current, markClass: 'diff-added' }
            "
          ></ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>

<ng-template #valueTpl let-value let-markClass="markClass">
  <pre *ngIf="value.isBlock; else plainValue" class="json-block"><ng-container *ngTemplateOutlet="valueText; context: { $implicit: value, markClass: markClass }"></ng-container></pre>
  <ng-template #plainValue>
    <span class="plain-value"><ng-container *ngTemplateOutlet="valueText; context: { $implicit: value, markClass: markClass }"></ng-container></span>
  </ng-template>
</ng-template>

<!-- changed parts of a value are wrapped in a coloured mark -->
<ng-template #valueText let-value let-markClass="markClass"><ng-container *ngIf="value.segments; else wholeText"><ng-container *ngFor="let seg of value.segments"><span *ngIf="seg.changed; else plainSeg" [class]="markClass" [ngStyle]="changeStyles[markClass]">{{ seg.text }}</span><ng-template #plainSeg>{{ seg.text }}</ng-template></ng-container></ng-container><ng-template #wholeText>{{ value.text }}</ng-template></ng-template>
